/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Track_JobInputs */

const en_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track a job`)
};

const de_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stelle verfolgen`)
};

const fr_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre un emploi`)
};

const es_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir un empleo`)
};

const it_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia un lavoro`)
};

const nl_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg een baan`)
};

const pl_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledź ogłoszenie`)
};

const fi_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraa työpaikkaa`)
};

const da_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spor et job`)
};

const sv_dashboard_step_track_job = /** @type {(inputs: Dashboard_Step_Track_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spåra ett jobb`)
};

/**
* | output |
* | --- |
* | "Track a job" |
*
* @param {Dashboard_Step_Track_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_track_job = /** @type {((inputs?: Dashboard_Step_Track_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Track_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_track_job(inputs)
	if (locale === "fr") return fr_dashboard_step_track_job(inputs)
	if (locale === "es") return es_dashboard_step_track_job(inputs)
	if (locale === "it") return it_dashboard_step_track_job(inputs)
	if (locale === "nl") return nl_dashboard_step_track_job(inputs)
	if (locale === "pl") return pl_dashboard_step_track_job(inputs)
	if (locale === "fi") return fi_dashboard_step_track_job(inputs)
	if (locale === "da") return da_dashboard_step_track_job(inputs)
	if (locale === "sv") return sv_dashboard_step_track_job(inputs)
	return en_dashboard_step_track_job(inputs)
});